//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.adapter

import blazern.lexisoup.graphql.model.TranslateQuery
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import kotlin.String
import kotlin.collections.List

public object TranslateQuery_ResponseAdapter {
  public object Data : Adapter<TranslateQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("translate")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): TranslateQuery.Data {
      var _translate: TranslateQuery.Translate? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _translate = Translate.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return TranslateQuery.Data(
        translate = _translate ?: missingField(reader, "translate")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: TranslateQuery.Data,
    ) {
      writer.name("translate")
      Translate.obj().toJson(writer, customScalarAdapters, value.translate)
    }
  }

  public object Translate : Adapter<TranslateQuery.Translate> {
    public val RESPONSE_NAMES: List<String> = listOf("translations", "source")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): TranslateQuery.Translate {
      var _translations: List<String>? = null
      var _source: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _translations = StringAdapter.list().fromJson(reader, customScalarAdapters)
          1 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return TranslateQuery.Translate(
        translations = _translations ?: missingField(reader, "translations"),
        source = _source ?: missingField(reader, "source")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: TranslateQuery.Translate,
    ) {
      writer.name("translations")
      StringAdapter.list().toJson(writer, customScalarAdapters, value.translations)

      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)
    }
  }
}
